import makeStyles from '@material-ui/core/styles/makeStyles';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { color } from '../../../app/theme';

const useStyles = makeStyles(
  () => ({
    button: {
      width: '100%',
      cursor: 'pointer',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '12px 16px',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      fontSize: 13,
      color: color.$2,
      fontWeight: '400',
      lineHeight: '13px',
      borderBottom: `1px solid ${color.$9}`,
      textAlign: 'center',
      '&:last-child': {
        border: 'none',
      },
    },
    list: {
      padding: '12px 0px',
      marginTop: 24,
      backgroundColor: color.$7,
      borderRadius: 12,
      boxShadow: '0 8px 36px 0 rgba(0, 0, 0, 0.06)',
    },
    card: ({ width }) => ({
      flex: '0 0 auto',
      display: 'flex',
      flexDirection: 'column',
      width: width || 204,
      margin: '0 8px 0 0',
      backgroundColor: color.$7,
      borderRadius: 12,
      boxShadow: '0 8px 36px 0 rgba(0, 0, 0, 0.06)',
      '&:last-child': {
        marginRight: 0,
      },
    }),
    textContainer: {
      flex: '1',
      padding: 12,
      borderBottom: `1px solid ${color.$9}`,
      overflowWrap: 'anywhere',
    },
    title: {
      color: color.$3,
      fontSize: '13px',
      fontWeight: '400',
      lineHeight: '18px',
    },
    subtitle: {
      marginTop: '4px',
      color: color.$11,
      wordBreak: 'break-word',
      whiteSpace: 'pre-wrap',
      fontSize: '13px',
      fontWeight: '400',
      lineHeight: '18px',
    },
    desc: {
      marginTop: '4px',
      fontSize: '11px',
      fontWeight: '400',
      lineHeight: '15px',
      color: color.$10,
      wordBreak: 'break-word',
      whiteSpace: 'pre-wrap',
    },
    hr: {
      height: 1,
      width: '100%',
      backgroundColor: color.$9,
      marginTop: 8,
      marginBottom: 8,
    },
    listButtonText: {
      fontSize: '15px',
      fontWeight: '500',
      lineHeight: '15px',
      color: color.$3,
    },
    tempBtnIndex: {
      position: 'absolute',
      minWidth: 20,
      height: 20,
      color: '#fff',
      backgroundColor: '#000',
      textAlign: 'center',
      borderRadius: '11px',
      padding: '4px 8px',
      fontSize: 13,
      fontWeight: 500,
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: 1,
      letterSpacing: 'normal',
      left: -34,
    },
    sectionBlock: {
      position: 'relative',
      display: 'flex',
      alignItems: 'start',
      margin: '8px 24px 0',
    },
  }),
  {
    name: 'WhatsAppListCard',
  },
);

function WhatsAppListCard({
  data,
  messageIndex,
  index,
  width,
  isShowList,
  elementTempBtnIndexTotal,
  isShowElementTempBtnIndex,
}) {
  const classes = useStyles({ width });
  const { t } = useTranslation();

  const sectionComponents = useMemo(() => {
    const components = [];
    const { sections = [], buttons = [] } = data;
    let tempBtnIndex = elementTempBtnIndexTotal - buttons.length - 1;

    sections?.forEach((section, sectionIndex) => {
      const buttonList = buttons.filter(
        btn => btn?.sectionIndex === sectionIndex,
      );
      components.push(
        <div
          key={`section-${sectionIndex}-title`}
          className={classes.title}
          style={{ margin: '0 24px', marginTop: sectionIndex ? 8 : 0 }}
        >
          {section}
        </div>,
      );
      buttonList?.forEach((btn, btnIndex) => {
        components.push(
          <div
            key={`sectionBlock-${sectionIndex}-${tempBtnIndex}-${btnIndex}`}
            className={classes.sectionBlock}
          >
            {isShowElementTempBtnIndex && (
              <div className={classes.tempBtnIndex}>{(tempBtnIndex += 1)}</div>
            )}
            <div>
              <div className={classes.subtitle} style={{ margin: 0 }}>
                {btn?.title}
              </div>
              {btn?.subtitle && (
                <div className={classes.desc}>{btn?.subtitle}</div>
              )}
            </div>
          </div>,
        );
      });
      if (sections?.length !== sectionIndex + 1) {
        components.push(
          <hr key={`sectionBlock-${sectionIndex}-hr`} className={classes.hr} />,
        );
      }
    });

    return components;
  }, [data, elementTempBtnIndexTotal, isShowElementTempBtnIndex]);

  return (
    <>
      <div
        className={classes.card}
        key={`preview-${messageIndex}-card-${index}`}
      >
        <div className={classes.textContainer}>
          <div className={classes.title}>{data.title || t('waList.title')}</div>
          <div className={classes.subtitle}>
            {data.subtitle || t('waList.subtitle')}
          </div>
          {data.desc && <div className={classes.desc}>{data.desc}</div>}
        </div>
        <div className={classes.button}>
          {data.listButtonText || t('waList.listButtonText')}
        </div>
      </div>
      {isShowList && (
        <div className={classes.list}>
          <div className={classes.listButtonText} style={{ margin: '0 24px' }}>
            {data.listButtonText}
          </div>
          <hr className={classes.hr} />
          {sectionComponents}
        </div>
      )}
    </>
  );
}

export default WhatsAppListCard;
